import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { InvoicePaymentAsk, blankPayAsk, payAskError } from "@/components/InvoicePaymentAsk";

// Toplu kesimde de ödeme sorulur: hepsinin ödemesi alındı (yöntem) / hiçbiri alınmadı → her faturanın kalan bakiyesi işlenir
export function BulkPayAskDialog({ ask, onCancel, onConfirm }) {
  const [pay, setPay] = useState(blankPayAsk(0));
  useEffect(() => { if (ask) setPay(blankPayAsk(ask.total)); }, [ask]);
  const need = !!ask && ask.total > 0.005;
  const err = need ? payAskError(pay, ask.total) : "";
  return (
    <Dialog open={!!ask} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="bulk-pay-ask-dialog">
        <DialogHeader><DialogTitle className="font-head text-xl">{ask?.count} fatura kesilecek</DialogTitle></DialogHeader>
        {need && <InvoicePaymentAsk value={pay} onChange={setPay} max={ask.total} contactTitle="ilgili cari" fullOnly />}
        {ask && !need && <p className="rounded-lg border border-emerald-300 bg-emerald-50 px-2.5 py-1.5 text-[11px] text-emerald-950" data-testid="bulk-pay-ask-skip">Seçili faturaların tahsil edilecek kalan bakiyesi yok (ödendi ya da hızlı satıştan geldi).</p>}
        <p className="text-[11px] text-muted-foreground">Tür her fatura için otomatik belirlenir. "Evet, alındı" seçilirse kesilen her faturanın kalan bakiyesi seçilen yöntemle tahsil edilmiş olarak işlenir.</p>
        {err && <p className="text-[11px] font-semibold text-red-600" data-testid="bulk-pay-ask-error">{err}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="bulk-pay-ask-cancel">Vazgeç</Button>
          <Button onClick={() => onConfirm(pay)} disabled={!!err} data-testid="bulk-pay-ask-confirm"><Send className="h-4 w-4 mr-1.5" />Kes</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
